module.exports = __webpack_public_path__ + "img/campus-small-3.3274562d.jpg";